import { schema } from 'normalizr';

export const workspace = new schema.Entity(
  'workspaces',
  {},
  {
    idAttribute: ws => ws.uuid,
    processStrategy: ws => ({
      uuid: ws.uuid,
      slug: ws.slug,
    }),
  }
);
